import generator from 'generate-password'

export default function RevealPassword(app) {

    let touchOn = false

    const $body = $('body')
    const selector = 'form .form-field .reveal-value'
    const generateBtn = 'form .form-field .generate-password'

    /**
     * Handle click event
     *
     * @param event
     */

    function onClick(event)
    {
        event.preventDefault()
    }

    /**
     * Reveal the password
     *
     * @param event
     */

    function revealPassword(event)
    {

        const $input = $(this).parents('.form-field').find(':input')

        if(event['type'] === 'touchend') {

            touchOn = !touchOn

            const type = touchOn ? 'text' : 'password'

            $input.attr( 'type', type )

        }

        if(touchOn) return

        if(event['type'] === 'mousedown') $input.attr('type', 'text')
        if(event['type'] === 'mouseup' || event['type'] === 'mouseout') $input.attr('type', 'password')

    }

    /**
     * Generate a random password
     *
     * @param event
     */

    function generate(event)
    {

        // Prevent default action
        event.preventDefault()

        // Generate and add the password
        $(this).parents('.form-field').find(':input').val(generator.generate({
            length: 10
        }))

    }

    $body.on('mousedown mouseup mouseout touchend', selector, revealPassword)
    $body.on('click', selector, onClick)
    $body.on('click', generateBtn, generate)

}
